import styled from '@emotion/styled';

import { CarnivalLayout } from '../CarnivalLayout';

// Container

export const Container = styled(CarnivalLayout)`
  ${p => p.theme.breakpoints.down('sm')} {
    --carnival-layout-padding-horizontal: 0;
  }
`;

// Centered

export const Centered = styled.div``;

// Content

export const Content = styled(CarnivalLayout.Content)`
  --feed-layout-content-gap: 1rem;

  width: 100%;
  max-width: 50rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--feed-layout-content-gap);

  ${p => p.theme.breakpoints.down('sm')} {
    --feed-layout-content-gap: 0.5rem;
  }
`;

// Sidebar

export const Sidebar = styled(CarnivalLayout.Sidebar)``;
